<template>
  <div class="vedioPlay">
    <div class="search-cancel">
      <input
        type="search"
        placeholder="搜索"
        class="input"
        v-model="keyword"
        @keyup.enter="handleKeyUp()"
      >
      <mt-button
        type="primary"
        size="small"
        @click="cancel"
      >取消</mt-button>
    </div>
    <div class="main">
      <div
        style="text-align:center;margin-top:0%;background: #f5f5f9;"
        v-if="loadmodal"
      >
        <mt-spinner
          color="#26a2ff"
          type="triple-bounce"
          class="loading-more"
          :size="30"
          style="display:inline-block"
        ></mt-spinner>
      </div>
      <div
        class="item-wrapper"
        v-infinite-scroll="loadMore"
        :infinite-scroll-disabled="isMoreLoading"
        infinite-scroll-distance="1"
        :infinite-scroll-immediate-check="true"
      >
        <div
          class="item"
          v-for="(item, index) in vedioList"
          :key="index"
        >
          <div class="title-btn">
            <h4 class="title">{{item.courseName}}</h4>
            <div class="btn-wrapper">
              <mt-button
                type="primary"
                size="small"
                @click="handleJump(item)"
              >进入</mt-button>
            </div>
          </div>
          <p>创建人: {{item.release.value}}</p>
          <p>{{item.createdTime}}</p>
          <p>{{item.describe}}</p>
        </div>

        <!-- 加载动画 -->
        <div
          class="bottomDh"
          style="text-align:center;margin-top:0%;"
          v-if="isLoading"
        >
          <mt-spinner
            color="#26a2ff"
            type="triple-bounce"
            class="loading-more"
            :size="30"
            style="display:inline-block"
          ></mt-spinner>
        </div>
        <!-- 提示没有更多 -->
        <div
          v-if="noMore"
          style="font-size:14px;text-align:center"
        >别拉了,没有啦~</div>
      </div>
      <div
        v-if="notdata"
        style="font-size:14px;text-align:center;"
      >
        暂无数据
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "mint-ui";
import { Indicator } from "mint-ui";
import { MessageBox } from "mint-ui";
import EaducationItem from "../components/EaducationItem";
import { getConsultationApi } from "../../api/consultationApi.js";
import moment from "moment";
export default {
  components: {},
  created() {
    localStorage.setItem("selected", "视频");
  },
  mounted() {
    this.getVedioList();
  },
  data() {
    return {
      keyword: "",
      loadmodal: true, //顶部加载动画
      notdata: false,
      isMoreLoading: false,
      vedioList: [],
      isLoading: true, //底部加载动画
      noMore: false, //显示没有更多
      pageInfo: {
        // 分页信息
        currentPage: 0,
        pagesize: 25,
        total: 0, // 总条数
        totalPage: 1 // 总分页数
      }
    };
  },
  methods: {
    // enter键执行搜索
    handleKeyUp(e) {
      this.pageInfo = { // 分页信息
        currentPage: 0,
        pagesize: 25,
        total: 0, // 总条数
        totalPage: 1 // 总分页数
      }
      this.getVedioList("", this.keyword);
    },
    cancel() {
      this.pageInfo = { // 分页信息
        currentPage: 0,
        pagesize: 25,
        total: 0, // 总条数
        totalPage: 1 // 总分页数
      }
      this.getVedioList();
      this.keyword = ''
    },
    handleJump(val) {
      let url = val.picture;
      this.$router.push({
        name: "VideoPlay",
        query: {
          courseId: val.id,
          imgSrc: url.replace(/\\/g, "/")
        }
      });
    },
    // 获取所有分类
    getVedioList(type, keyword) {
      this.noMore = false;
      this.notdata = false;
      if (type == "loadMore") {
        this.loadmodal = false; //顶部加载动画
        this.isLoading = true; //底部的加载动画
      } else {
        this.loadmodal = true;
        this.isLoading = false;
      }
      if (keyword != "" && keyword != undefined) {
        var query = {
          status: this.status,
          start: this.pageInfo.currentPage + 1,
          pagesize: this.pageInfo.pagesize,
          keyword: keyword
        };
      } else {
        var query = {
          status: this.status,
          start: this.pageInfo.currentPage + 1,
          pagesize: this.pageInfo.pagesize
        };
      }
      this.Axios.get("/api/Education/SearchEducation", {
        params: query
      }).then(res => {
        const data = res.data;
        if (data.status == 100) {
          // 请求成功隐藏顶部动画
          this.loadmodal = false;

          data.total == 0 ? this.notdata = true : this.notdata = false;

          if (type === 'loadMore') {
            this.vedioList = this.vedioList.concat(data.data)
          } else {
            this.vedioList = data.data
          }

          if (this.vedioList.length >= data.total) {
            this.isLoading = false;
            this.noMore = true;
          }
          //总条数
          this.pageInfo.total = data.total;
          //总页数
          this.pageInfo.totalPage = Math.ceil(
            this.pageInfo.total / this.pageInfo.pagesize
          )
          if (query.pageindex > this.pageInfo.totalPage) {
            this.isLoading = false;
            this.noMore = true;
          }
        }
      })
    },
    loadMore() {
      this.pageInfo.currentPage += 1; // 增加分页
      this.isMoreLoading = true; // 设置加载更多中
      this.isLoading = true; // 底部加载动画
      this.loadmodal = false; //顶部加载动画
      if (this.pageInfo.currentPage > this.pageInfo.totalPage) {
        // 超过了分页
        this.noMore = true; // 显示没有更多了
        this.isLoading = false; // 关闭加载中
        return false;
      }
      // 做个缓冲
      setTimeout(() => {
        this.getVedioList("loadMore");
      }, 100);
    }
  }
};
</script>

<style lang="less">
.vedioPlay {
  height: 100%;
  // border:  1px solid red;
  .search-cancel {
    background: #f5f5f9;
    height: 32px;
    // border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    padding-left: 3%;
    padding-top: 10px;
    padding-bottom: 10px;
    .input {
      width: 67%;
      height: 30px;
      border: white;
      border-radius: 4px;
      text-align: center;
      outline: none;
    }
    .mint-button--small {
      height: 26px;
      margin-left: 4%;
    }
  }
  .main {
    height: 100%;
    height: ~"calc(100% - 53px)";
    width: 100%;
    // border: 1px solid rebeccapurple;
    overflow: hidden;
    .item-wrapper {
      height: 100%;
      overflow: auto;
      background: #f5f5f9;
      position: relative;
      // border: 1px solid rebeccapurple;
      .item {
        width: 92%;
        padding-left: 4%;
        padding-right: 4%;
        background: white;
        padding-top: 4%;
        padding-bottom: 1%;
        margin-bottom: 8px;
        font-size: 14px;
        .title-btn {
          width: 100%;
          overflow: hidden;
          h4 {
            margin: 0;
            font-size: 16px;
            margin-bottom: 15px;
            font-weight: 550;
            min-width: 70%;
            float: left;
          }
          .btn-wrapper {
            float: right;
            .mint-button {
              height: 26px;
            }
          }
        }
        p {
          margin: 0;
          margin-bottom: 10px;
          color: #aeaeae;
        }
      }
    }
  }
  input::-webkit-input-placeholder, textarea::-webkit-input-placeholder, select {
    font-weight: 400 !important;
    color: rgb(102, 102, 102) !important;
    font-size: 14px !important;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }
  input::-moz-placeholder, textarea::-moz-placeholder {
    font-weight: 400 !important;
    color: rgb(102, 102, 102) !important;
    font-size: 14px !important;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }
  input::-ms-input-placeholder, textarea::-ms-input-placeholder {
    font-weight: 400 !important;
    color: rgb(102, 102, 102) !important;
    font-size: 14px !important;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif;
  }
}
</style>
